import { map, tap } from 'rxjs/operators';
import { BaseBloc } from '@core/utils/bloc';
import { LoadingState } from '@core/utils/repository/loading_state';
import { BehaviorSubject, of } from 'rxjs';
import { GlossaryAPI } from '@business/api/glossary';
import { GlossaryResponse, GlossaryId } from '@business/entities/glossary';
import { CommonService } from '@business/services';
import { resolve } from '@core/utils/ioc';
import { Blocs } from '@business/blocs';
import { CourseStepResponse } from '@business/entities/course';

export class GlossaryBlockBloc extends BaseBloc {
  private readonly courseBloc = resolve(Blocs.course);
  constructor(private glossaryId?: GlossaryId[]) {
    super();
  }

  readonly item$ = new BehaviorSubject<GlossaryResponse | null>(null);
  readonly items$ = new BehaviorSubject<GlossaryResponse[]>([]);
  readonly courseStep$ = new BehaviorSubject<CourseStepResponse | null>(null);
  loading = new LoadingState();

  searchGlossaries = (search: string) => {
    return GlossaryAPI.searchGlossary(search).pipe(map(data => CommonService.selectItems(data, 'title', 'id')));
  };

  onInit() {
    return GlossaryAPI.fetchGlossaries(true).pipe(tap(data => this.items$.next(data)));
  }

  onReload(lessonId: string) {
    return this.courseBloc.getStep(lessonId);
  }
}
